import { Card, CardContent } from '@/components/ui/shadcn/card'
import { Button } from '@/components/ui/shadcn/button'
import { CheckCircle2 } from 'lucide-react'
import { cn } from '@/lib/utils'

const Feature = ({ children }) => (
  <li className="flex items-start gap-2 text-sm">
    <CheckCircle2 className="mt-0.5 size-4 shrink-0 text-emerald-600" />
    <span>{children}</span>
  </li>
)

const renderTierFeatures = tier => (
  <ul className="space-y-1.5">
    <Feature>{tier.inputTokenLimit.toLocaleString()} input tokens</Feature>
    <Feature>{tier.outputTokenLimit.toLocaleString()} output tokens</Feature>
    <Feature>{tier.integrationLimit} integrations included</Feature>
    <Feature>{tier.minuteLimit} minutes of transcription</Feature>
    {tier.team && (
      <Feature>Team plan (minimum {tier.minTeamSize} users)</Feature>
    )}
  </ul>
)

export default function BillingTierSelect({
  tiers,
  currentTier,
  handleTierSelect,
  handleClose,
}) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {tiers.map(tier => (
          <Card
            key={tier.name}
            className={cn(
              'gap-3 py-4 h-full',
              currentTier === tier.name && 'ring-2 ring-primary',
            )}
          >
            <CardContent className="px-4 flex flex-col gap-3">
              <h6 className="text-base font-semibold">{tier.name}</h6>
              <p className="text-2xl font-bold">
                ${tier.price}/month
                {tier.team && (
                  <span className="ml-1 text-xs font-normal text-muted-foreground">
                    per user
                  </span>
                )}
              </p>
              {renderTierFeatures(tier)}
              {currentTier === tier.name && tier.team && (
                <Button
                  className="w-full mt-2"
                  onClick={() => handleTierSelect(tier)}
                >
                  Manage Users
                </Button>
              )}
              <Button
                className="w-full mt-2"
                onClick={() => handleTierSelect(tier)}
                disabled={currentTier === tier.name}
              >
                {currentTier === tier.name ? 'Chosen' : 'Choose'}
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="flex justify-end">
        <Button
          onClick={handleClose}
          variant="outline"
          className="border-destructive text-destructive hover:bg-destructive/10"
        >
          Cancel
        </Button>
      </div>
    </div>
  )
}
